export const STATION_NARRATIVE_IS_SHOWN = 'stationNarrativeIsShown';
export const STATION_NARRATIVES_HIDDEN = 'stationNarrativesHidden';
